export default __webpack_public_path__ + "static/media/postgresql.4e1dc920.svg";